import { Box, Flex, IconButton, Text } from "@chakra-ui/react";
import { FaRegBuilding, FaRegCalendarAlt, FaTrash } from "react-icons/fa";
import { CrmTask } from "../../../models/Task";
import { crm, Pill, ResponsibleChip } from "./crmTheme";

const TaskCard = ({
  task,
  onDragStart,
  onClick,
  onDelete,
}: {
  task: CrmTask;
  onDragStart: (e: React.DragEvent, task: CrmTask) => void;
  onClick: (task: CrmTask) => void;
  onDelete: (task: CrmTask) => void;
}) => {
  const overdue =
    task.dueDate && new Date(task.dueDate).getTime() < Date.now();

  return (
    <Box
      role="group"
      draggable
      onDragStart={(e) => onDragStart(e, task)}
      onClick={() => onClick(task)}
      bg={crm.surface}
      borderRadius="10px"
      border={`1px solid ${crm.border}`}
      boxShadow={crm.shadowSm}
      p="12px"
      cursor="grab"
      _hover={{
        boxShadow: crm.shadowMd,
        transform: "translateY(-1px)",
        borderColor: crm.brand,
      }}
      _active={{ cursor: "grabbing" }}
      transition="all .12s ease"
    >
      <Flex justify="space-between" align="flex-start" gap="8px">
        <Text fontWeight="600" noOfLines={2} color={crm.text} fontSize="sm">
          {task.title}
        </Text>
        <IconButton
          aria-label="Excluir task"
          icon={<FaTrash />}
          size="xs"
          variant="ghost"
          colorScheme="red"
          flexShrink={0}
          opacity={0}
          _groupHover={{ opacity: 1 }}
          transition="opacity .12s"
          onClick={(e) => {
            e.stopPropagation();
            onDelete(task);
          }}
        />
      </Flex>

      {task.description && (
        <Text fontSize="sm" color={crm.textMuted} noOfLines={2} mt="4px">
          {task.description}
        </Text>
      )}

      <Flex mt="10px" gap="6px" flexWrap="wrap" alignItems="center">
        {task.dueDate && (
          <Pill
            bg={overdue ? "#fef2f2" : crm.brandSoft}
            color={overdue ? crm.danger : crm.brand}
          >
            <FaRegCalendarAlt size={9} />
            {new Date(task.dueDate).toLocaleDateString("pt-BR")}
          </Pill>
        )}
        {task.responsibleName && (
          <ResponsibleChip name={task.responsibleName} />
        )}
        {task.prospectName && (
          <Pill>
            <FaRegBuilding size={9} />
            {task.prospectName}
          </Pill>
        )}
      </Flex>
    </Box>
  );
};

export default TaskCard;
